export const orderStatuses = {
  SUCCESS: 'success',
  REJECTED: 'rejected',
  PAYMENT_PROVIDER: 'payment-provided',
  EXPIRED: 'expired',
  CHECK: 'check',
  CART: 'cart'
}
